<main class="main users chart-page card card-body" id="skip-target">
    <div class="container-fluid cardone">
      <p-toast position="center" key="c" [baseZIndex]="5000">
  
      </p-toast>
      <!-- <p class="stat-cards-info__title title">Excursion</p> -->
      <div class="row">
        <h2 class="col-6 main-title">Transfer</h2>
        <h2 hidden class="col-6 main-title" data-toggle="collapse" data-target="#advanceSearch" aria-expanded="false" aria-controls="advanceSearch" style="text-align: right;">Advance Search</h2>
      </div>
      
      <form #formRow [formGroup]="transferForm" (ngSubmit)="transfer_search_FormSubmit(false)">
        <div class="row">
            <div *ngIf="this.appClient != 'RoyalPark'" class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">Sort by Flight Time:</label>
                </div>
                <div class="col-12">
                    <ng-select [searchable]="false" formControlName="sortby">
                        <ng-option *ngFor="let pr of sortByFlightlist" [value]="pr.id">{{pr.value}}</ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
              <div class="col-12">
                  <label class="form-label" for="name">Service Date From</label>
              </div>
              <div class="col-12">
                  <p-calendar #theCalendar [readonlyInput]="true" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                  dateFormat="dd-m-yy" formControlName="transferfromdate"></p-calendar>
              </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
              <div class="col-12">
                  <label class="form-label" for="name">Service Date To</label>
              </div>
              <div class="col-12">
                  <p-calendar #theCalendar [readonlyInput]="true" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                  dateFormat="dd-m-yy" formControlName="transfertodate"></p-calendar>
              </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
              <div class="col-12">
                  <label class="form-label" for="name">Request Id</label>
              </div>
              <div class="col-12">
                  <input type="text" formControlName="RId" pInputText placeholder="Request Id">
              </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="servicetype">Service Type</label>
            </div>
            <div class="col-12">
                <ng-select [searchable]="false" formControlName="servicetype">
                    <ng-option *ngFor="let pr of serviceTypeList" [value]="pr.id">{{pr.value}}</ng-option>
                </ng-select>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="user">RO Name</label>
            </div>
            <div class="col-12">
              <p-autoComplete formControlName="user" (ngModelChange)="userChange($event)" 
                [suggestions]="filteredUser" (completeMethod)="filterUser($event)" field="UserName" [minLength]="1">
              </p-autoComplete>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="agent">Agent</label>
            </div>
            <div class="col-12">
              <p-autoComplete formControlName="agent" (ngModelChange)="agentChange($event)" 
                [suggestions]="filteredAgent" (completeMethod)="filterAgent($event)" field="agentname" [minLength]="1">
              </p-autoComplete>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="Status">Division</label>
            </div>
            <div class="col-12">
              <ng-select [searchable]="false" formControlName="division">
                  <ng-option value="ShowAll">Show All</ng-option>
                  <ng-option *ngFor="let pr of DivisionList" [value]="pr.division_master_code">{{pr.division_master_des}}</ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="Status">Status</label>
            </div>
            <div class="col-12">
              <ng-select [searchable]="false" formControlName="status">
                  <ng-option *ngFor="let pr of StatusListSearch" [value]="pr.id">{{pr.value}}</ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12 ">
              <button type="submit" class="primary-default-btn">Search</button>
            </div>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12 ">
              <button type="button" (click)="reset()" style="background-color: #9e9e9e"
                class="primary-default-btn">Clear</button>
            </div>
          </div>
          <!-- <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12">
              <div class="col-12">
                  <span>&nbsp;</span>
              </div>
              <div class="col-12">
                  <button type="button" (click)="AssignDriverSupplier()" class="primary-default-btn">Assign Driver/Supplier</button>
              </div>
          </div> -->
        </div>
        <div class="row">
          
        </div>
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 lgdis"></div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 lgdis"></div>
        </div>
        <div class="row">
          <br>
        </div>
      </form>
      <div class="row cardone">
        
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="supplierType">Type</label>
            </div>
            <div class="col-12">
                <ng-select [searchable]="false" [clearable]="false" [(ngModel)]="SupplierType" (change)="supplierTypeChange($event)">
                    <ng-option *ngFor="let pr of supplierTypelist" [value]="pr.id">{{pr.value}}</ng-option>
                </ng-select>
            </div>
          </div>
          <div *ngIf="SupplierType=='Supplier'" class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="name">Supplier</label>
            </div>
            <div class="col-12">
              <p-autoComplete [(ngModel)]="selectedsupplier" (ngModelChange)="supplierChange($event)" 
                [suggestions]="filteredSupplier" (completeMethod)="filterSupplier($event)" field="partyname" [minLength]="1">
              </p-autoComplete>
            </div>
          </div>
          <div *ngIf="SupplierType=='Own Asset'" class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="name">Driver</label>
            </div>
            <div class="col-12">
              <p-autoComplete [(ngModel)]="selectedDriver" (ngModelChange)="driverChange($event)" 
                [suggestions]="filteredDriver" (completeMethod)="filterDriver($event)" field="drivername" [minLength]="1">
              </p-autoComplete>
            </div>
          </div>
          <div *ngIf="SupplierType=='Airport Rep'" class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="name">Airport Representative</label>
            </div>
            <div class="col-12">
              <p-autoComplete [(ngModel)]="selectedAirportRep" (ngModelChange)="airportrepChange($event)" 
                [suggestions]="filteredAirportRep" (completeMethod)="filterAirportRep($event)" field="repname" [minLength]="1">
              </p-autoComplete>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12">
              <button type="button" (click)="SaveDriverSupplier()"
                class="primary-default-btn">
                <span *ngIf="SupplierType=='Supplier'">Update Supplier</span>
                <span *ngIf="SupplierType=='Own Asset'">Update Driver</span>
                <span *ngIf="SupplierType=='Airport Rep'">Update Airport Rep</span>
              </button>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="name">More Action</label>
            </div>
            <div class="col-12">
                <ng-select [searchable]="false" [(ngModel)]="MoreAction" (ngModelChange)="moreActionChange($event)">
                    <ng-option *ngFor="let pr of MoreActionlist" [value]="pr.id">{{pr.value}}</ng-option>
                </ng-select>
            </div>
          </div>
        <div>
          <p-scrollPanel [style]="{width: '100%', height: '65vh'}">
            <div style="width: 95%;margin: 20px;" class="card table-responsive">
              <p-table responsiveLayout="stack" (onPage)="onTransferPageChange($event)" [value]="transferlist" 
              styleClass="p-datatable-gridlines" [loading]="loading" [paginator]="true" [rows]="10"
              [(first)]="transferPageIndex" [showCurrentPageReport]="true" dataKey="RowNum"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [rowsPerPageOptions]="[10,20,50]" rowExpandMode="single" [expandedRowKeys]="expandedRows">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th style="width: 3rem"></th>
                  <th>Voucher No</th>
                  <!-- <th>Id</th> -->
                  <th>Request Id</th>
                  <!-- <th>Voucher No</th> -->
                  <th>Service</th>
                  <th>Service Date</th>
                  <!-- <th>Service Type</th> -->
                  <th>SIC / Private</th>
                  <th>Vehicle Type</th>
                  <!-- <th>Customer</th> -->
                  <!-- <th>Customer Country</th> -->
                  <!-- <th>Flight No</th> -->
                  <!-- <th>Flight Time</th>  -->
                   <!-- <th>Transit Dep Flight No & Time</th> -->
                  <th>Pickup Location</th>
                  <!-- <th>Pickup Time</th> -->
                  <th>DropOff Location</th> 
                  <th>Pax</th>
                  <th>Total Pax</th>
                  <!-- <th>Driver Name</th>-->
                  <th>Supplier/Driver Name</th>
                  <th>Airport Rep Name</th>
                  <!-- <th>Supplier Conf No</th> -->
                  <th>Status</th>
                  <!-- <th>Pending amount from Guest</th>
                  <th>Pending amount for approval</th> -->
                  <th>Email Send</th>
                  <!-- <th>Proforma Invoice</th> -->
                  <!-- <th>Action</th> -->
                  <th style="width: 3rem"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData let-product let-columns="columns" let-expanded="expanded">
                <tr style="max-height: 30px;" [ngClass]="getTransferRowClass(product)">
                  
                  <!-- <td *ngIf="product.assignmentid === null">
                    <input type="checkbox" class="form-check-input" (change)="productChecked($event, rowIndex)" [checked]="product.isChecked">
                  </td> -->
                  <!-- <td *ngIf="product.assignmentid !== null"></td> -->
                  <td>
                    <input type="checkbox" [disabled]="(product.shuttle != this.selectedRow_VC) && this.selectedRow_VC != -1" class="form-check-input" (change)="productChecked($event, rowIndex)" [checked]="product.isChecked">
                  </td>
                  <td><span class="p-column-title">Voucher No</span>{{product.voucherno}}</td>
                  <!-- <td disabled="true"><span class="p-column-title">Id</span>{{product.assignmentid}}</td> -->
                  <td><span class="p-column-title">Request Id</span>{{product.requestid}}</td>
                  <!-- <td>Voucher No</td> -->
                  <td *ngIf="product.ServiceType == 'TRANSFER'" [ngClass]="product.ServiceType == 'TRANSFER' ? 'serviceTypeTransbgClr' : 'serviceTypeNonTransbgClr'"><span class="p-column-title">Service</span>{{product.transfertype}} - {{product.ServiceType}}</td>
                  <td *ngIf="product.ServiceType == 'AIRPORT'" [ngClass]="product.ServiceType == 'TRANSFER' ? 'serviceTypeTransbgClr' : 'serviceTypeNonTransbgClr'"><span class="p-column-title">Service</span>Airport Services</td>
                  <td><span class="p-column-title">Service Date</span>{{product.servicedate | date:'dd-MM-yyyy'}}</td>
                  <!-- <td><span class="p-column-title">Service Type</span>{{product.transfertype}}</td> -->
  
                  <td *ngIf="product.shuttle == 0 && product.ServiceType == 'TRANSFER'"><span class="p-column-title">SIC / Private</span>Private</td>
                  <td *ngIf="product.shuttle == 1 && product.ServiceType == 'TRANSFER'"><span class="p-column-title">SIC / Private</span>SIC</td>
                  <td *ngIf="product.ServiceType == 'AIRPORT'" ></td>
  
                  <td><span class="p-column-title">Vehicle Type</span>{{product.othcatname}}</td>
                  <!-- <td><span class="p-column-title">Customer</span>{{product.agentname}}</td> -->
                  <!-- <td>Country</td> -->
                  <!-- <td><span class="p-column-title">Flight No</span>{{product.flightcode}}</td> -->
                  <!-- <td><span class="p-column-title">Flight Time</span>{{product.flighttime}}</td> -->
                  <!-- <td><span class="p-column-title">Transit Dep Flight No & Time</span>{{product.trdepflightcode}}  {{product.trdepflighttime}}</td> -->
  
                  <td *ngIf="product.transfertype == 'ARRIVAL'"><span class="p-column-title">Pickup Location</span>{{product.pickupName}}</td>
                  <td *ngIf="product.transfertype != 'ARRIVAL' && product.hotelconfno !== null"><span class="p-column-title">Pickup Location</span>
                    {{product.pickupName}} Hotel Conf No:{{product.hotelconfno}}
                  </td>
                  <td *ngIf="product.transfertype != 'ARRIVAL' && product.hotelconfno === null"><span class="p-column-title">Pickup Location</span>
                    {{product.pickupName}}
                  </td>
                  <!-- <td><span class="p-column-title">Pickup Time</span>{{product.pickupTime}}</td> -->
  
                  <td *ngIf="product.transfertype != 'ARRIVAL'"><span class="p-column-title">Dropoff Location</span>{{product.dropoffName}}</td>
                  <td *ngIf="product.transfertype == 'ARRIVAL' && product.hotelconfno !== null"><span class="p-column-title">Dropoff Location</span>
                    {{product.dropoffName}} Hotel Conf No:{{product.hotelconfno}}
                  </td>
                  <td *ngIf="product.transfertype == 'ARRIVAL' && product.hotelconfno === null"><span class="p-column-title">Dropoff Location</span>
                    {{product.dropoffName}}
                  </td>
  
                  <td *ngIf="product.child > 0"><span class="p-column-title">Pax</span>{{product.adults}} Adults {{product.child}} Child({{product.childagestring}})</td>
                  <td *ngIf="product.child == 0"><span class="p-column-title">Pax</span>{{product.adults}} Adults</td>
  
                  <td><span class="p-column-title">Total Pax</span>{{product.TotalPax}}</td>

                  <!-- <td><span class="p-column-title">Driver Name</span>{{product.DriverName}}</td> -->
                  <td>
                    <span class="p-column-title">Supplier/Driver Name</span>{{product.preferredsuppliername}}
                    <span *ngIf="product.DriverName != ''"> / {{product.DriverName}}</span>
                  </td>
                  <td>
                    {{product.RepName}}
                  </td>
                  <!-- <td>Supplier ConfNo</td> -->
  
                  <td *ngIf="product.assign_status === null || product.assign_status === 'Pending' || product.assign_status === ''"><span class="p-column-title">Status</span>Pending</td>
                  <td *ngIf="product.assign_status == 'Confirmed'"><span class="p-column-title">Status</span>Confirmed</td>
                  <td *ngIf="product.assign_status == 'not confirmed'"><span class="p-column-title">Status</span>Not confirmed</td>
                  <td *ngIf="product.assign_status == 'Cancelled'"><span class="p-column-title">Status</span>Cancelled</td>
                  <td *ngIf="product.assign_status == 'Assigned'"><span class="p-column-title">Status</span>Assigned</td>
  
                  <!-- <td><span class="p-column-title">Pending amount from Guest</span></td>
                  <td><span class="p-column-title">Pending amount for approval</span></td> -->
  
                  <td *ngIf="product.assignmentid !== null && product.shuttle == 0 && product.ServiceType !='AIRPORT' && product.preferredsuppliername !='OWN TRANSPORT'">
                    <!-- <input type="checkbox" id="chkEmail"> -->
                    <span *ngIf="product.mailsent == 1 && product.assignmentid !== null">Mail Send</span>
                    <span *ngIf="!(product.mailsent == 1 && product.assignmentid !== null)">Mail Not Send</span>
                  </td>
                  <td *ngIf="!(product.assignmentid !== null && product.shuttle == 0 && product.ServiceType !='AIRPORT' && product.preferredsuppliername !='OWN TRANSPORT')">
                    <span class="p-column-title">Email</span>
                  </td>
                  <!-- <td>Proforma Invoice</td> -->
  
                  <!-- <td *ngIf="product.assignmentid !== null"><span class="p-column-title">Action</span>
                    <button (click)="viewbookings(product)" class="primary-default-btn"><i class="pi pi-pencil"
                      style="color:#ffffff;"></i></button>
                    <button (click)="viewbookings(product)" class="primary-default-btn"><i class="pi pi-eye"
                      style="color:#ffffff;"></i></button>
                  </td>
                  <td *ngIf="product.assignmentid === null"><span class="p-column-title">Action</span></td> -->
                  <td>
                    <button type="button" pButton pRipple [pRowToggler]="product" 
                      [disabled]="(product.shuttle != this.selectedRow_VC) && this.selectedRow_VC != -1"
                      (click)=" (!expanded) ? getTransferSingle(product, rowIndex) : null"
                      class="p-button-text p-button-rounded p-button-plain"
                      [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-left'"></button>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="rowexpansion" let-product let-rowIndex="rowIndex" let-rowData
                  let-columns="columns">
                  <tr>
                    <td [attr.colspan]="16">
                      <div class="p-p-3 tableForm">
                        <p-tabView>
                          <!--<form [formGroup]="transferDetailForm" (ngSubmit)="transferDetailSave(this.transferlist[rowIndex]['detail'][0], rowIndex)">-->
                            <p-tabPanel header="Airport / Transfer Details">
                              <div class="row">
                                <div *ngIf="this.transferlist[rowIndex]['ServiceType'] == 'TRANSFER'" class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="Status">Vehicle Category</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" *ngIf="this.transferlist[rowIndex]['detail'][0]['shuttle'] == 0" value="Private" readonly disabled="true">
                                      <input type="text" *ngIf="this.transferlist[rowIndex]['detail'][0]['shuttle'] == 1" value="SIC" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <!-- <input type="text" id="VehicleCategory" pInputText #myInput [readOnly]="!this.isEdit" [disabled]="!this.isEdit" 
                                        (ngModelChange)="transferInputChange(myInput.id, $event, rowIndex)" 
                                        [(ngModel)]="tabVehicleCategory" placeholder="Vehicle Category"> -->

                                      <ng-select [searchable]="false" #mySelect (ngModelChange)="transferSelectChange($event, rowIndex)" 
                                        [(ngModel)]="tabVehicleCategory">
                                          <ng-option *ngFor="let pr of vehicleCategoryList" [value]="pr.id">{{pr.value}}</ng-option>
                                      </ng-select>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="Status">Vehicle Type / Service Type</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['othcatname']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <p-autoComplete [(ngModel)]="tabVehicleType" (ngModelChange)="vehicleTypeChange($event)" 
                                        [suggestions]="filteredVehicleType" (completeMethod)="filterVehicle($event)" id="othcatcode" name="othcatname" field="othcatname" [minLength]="1">
                                      </p-autoComplete>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="Status">Status</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['assign_status']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <ng-select [searchable]="false" #mySelect (ngModelChange)="transferSelectChange($event, rowIndex)" 
                                        [(ngModel)]="tabStatus">
                                          <ng-option *ngFor="let pr of StatusList" [value]="pr.id">{{pr.value}}</ng-option>
                                      </ng-select>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="ConfNo">Conf No</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['confno']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <input type="text" id="confno" pInputText #myInput [readOnly]="!this.isEdit" [disabled]="!this.isEdit"
                                        (ngModelChange)="transferInputChange(myInput.id, $event, rowIndex)" 
                                        [(ngModel)]="tabConfNo" placeholder="Conf No">
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="vehicleType">Vehicle No</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['vehicleno']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <input type="text" id="vehicleno" pInputText #myInput [readOnly]="!this.isEdit" [disabled]="!this.isEdit"
                                        (ngModelChange)="transferInputChange(myInput.id, $event, rowIndex)"
                                        [(ngModel)]="tabVehicleNo" placeholder="Vehicle No">
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Flight No</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['flightcode']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <p-autoComplete [(ngModel)]="tabFlightNo" (ngModelChange)="flightNoChange($event)" 
                                        [suggestions]="filteredFlightNo" (completeMethod)="filterFlight($event)" field="flightcode" [minLength]="1">
                                      </p-autoComplete>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Flight Time</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['flighttime']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <input type="text" id="flighttime" pInputText #myInput [readOnly]="!this.isEdit" [disabled]="!this.isEdit" 
                                        (ngModelChange)="transferInputChange(myInput.id, $event, rowIndex)" 
                                        [(ngModel)]="tabFlightTime" placeholder="Flight Time">
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Pickup Location</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['pickupName']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <p-autoComplete [(ngModel)]="tabPickupLocation" (ngModelChange)="pickupLocationChange($event)" 
                                        [suggestions]="filteredPickupLocation" (completeMethod)="filterPickupLocation($event,(this.transferlist[rowIndex]['detail'][0]['transfertype']))" field="partyname" [minLength]="1">
                                      </p-autoComplete>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Dropoff Location</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['dropoffName']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <p-autoComplete [(ngModel)]="tabDropoffLocation" (ngModelChange)="dropOffLocationChange($event)" 
                                        [suggestions]="filteredDropoffLocation" (completeMethod)="filterDropoffLocation($event,(this.transferlist[rowIndex]['detail'][0]['transfertype']))" field="partyname" [minLength]="1">
                                      </p-autoComplete>
                                    </div>
                                    <!-- <input type="text" id="dropoffName" pInputText #myInput 
                                      (ngModelChange)="transferInputChange(myInput.id, $event, rowIndex)"  
                                      [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['dropoffName']" placeholder="Dropoff Location"> -->
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Sale Value
                                        <span *ngIf="this.tabSaleCurrCode != '' && this.tabSaleCurrCode != undefined"> ({{this.tabSaleCurrCode}})</span>
                                      </label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['unitsalevalue']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <input type="text" pInputText readonly disabled="true" [(ngModel)]="tabUnitSaleValue" placeholder="Sale Value">
                                    </div>
                                  </div>
                                </div>
                                <div *ngIf="this.tabCostCurrCode != this.tabSaleCurrCode" class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Sale Value
                                        <span *ngIf="this.tabCostCurrCode != '' && this.tabCostCurrCode != undefined"> ({{this.tabCostCurrCode}})</span>
                                      </label>
                                  </div>
                                  <div class="col-12">
                                    <div>
                                      <input type="text" pInputText readonly disabled="true" [(ngModel)]="tabUnitSaleValueDiffCurr" placeholder="Sale Value">
                                    </div>
                                  </div>
                                </div>
                                <div *ngIf="this.appClient != 'RoyalPark'" class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Total Sale Value
                                        <span *ngIf="this.tabSaleCurrCode != '' && this.tabSaleCurrCode != undefined"> ({{this.tabSaleCurrCode}})</span>
                                      </label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['totalsalevalue']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <input type="text" pInputText readonly disabled="true" [(ngModel)]="tabTotalSaleValue" placeholder="Total Sale Value">
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Cost Price
                                        <span *ngIf="this.tabCostCurrCode != '' && this.tabCostCurrCode != undefined"> ({{this.tabCostCurrCode}})</span>
                                      </label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['unitcostvalue']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <input type="number" (blur)="UnitCostValueChange($event, rowIndex)" [disabled]="overridecheck" [(ngModel)]="tabUnitCostValue" placeholder="Cost Price">
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Parking Fee
                                        <span *ngIf="this.tabCostCurrCode != '' && this.tabCostCurrCode != undefined"> ({{this.tabCostCurrCode}})</span>
                                      </label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['parkingfee']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <input type="number" pInputText (blur)="ParkingFeeValueChange($event, rowIndex)" [disabled]="overridecheck" [(ngModel)]="tabParkingFee" placeholder="Parking Fee">
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                    <label class="form-label" for="name"><br></label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="checkbox" [checked]="this.transferlist[rowIndex]['detail'][0]['overridecost']" readonly disabled="true"><span style="font-size: 14px;padding-left: 10px;">Override Cost Price</span>
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <input type="checkbox" [checked]="tabOverrideCostCheck" (change)="OverrideCostCheckChange($event)"><span style="font-size: 14px;padding-left: 10px;">Override Cost Price</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Total Cost Price
                                        <span *ngIf="this.tabCostCurrCode != '' && this.tabCostCurrCode != undefined"> ({{this.tabCostCurrCode}})</span>
                                      </label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['totalcostprice']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <input type="text" pInputText readonly disabled="true" [(ngModel)]="tabTotalCostPrice" placeholder="Total Cost Price">
                                    </div>
                                  </div>
                                </div>
                                <div *ngIf="this.appClient != 'RoyalPark'" class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Total Profit
                                        <span *ngIf="this.tabCostCurrCode != '' && this.tabCostCurrCode != undefined"> ({{this.tabCostCurrCode}})</span>
                                      </label>
                                  </div>
                                  <div class="col-12">
                                    <input type="text" pInputText readonly disabled="true" [(ngModel)]="tabTotalProfit" placeholder="Total Profit">
                                  </div>
                                </div>
                                <div *ngIf="this.appClient != 'RoyalPark'" class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Total Profit %</label>
                                  </div>
                                  <div class="col-12">
                                    <input type="text" pInputText readonly disabled="true" [(ngModel)]="tabTotalProfitPerc" placeholder="Total Profit %">
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Pickup Time</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['pickuptime']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <p-inputMask mask="99:99" [(ngModel)]="tabPickupTime" (ngModelChange)="pickupTimeChange($event)" placeholder="HH:mm" slotChar="HH:mm"></p-inputMask>
                                      <!-- <p-calendar #theCalendar [readonlyInput]="true" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['pickuptime']" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                                        dateFormat="dd-m-yy"></p-calendar> -->
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">Start Date & Time</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['starttime']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <p-inputMask mask="99-99-9999 99:99" [(ngModel)]="tabStartDateTime" (ngModelChange)="startDateTimeChange($event)" characterPattern="^\d{2}/(0[1-9]|1[0-2])/\d{4}$" placeholder="dd-mm-yyyy HH:mm" slotChar="dd-mm-yyyy HH:mm"></p-inputMask>
                                      <!-- <p-calendar #theCalendar [readonlyInput]="true" [monthNavigator]="true" [yearNavigator]="true" [showTime]="true" [showSeconds]="false" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                                        dateFormat="dd-m-yy"></p-calendar> -->
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                  <div class="col-12">
                                      <label class="form-label" for="supplierType">End Date & Time</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['endtime']" readonly disabled="true">
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <p-inputMask mask="99-99-9999 99:99" [(ngModel)]="tabEndDateTime" (ngModelChange)="endDateTimeChange($event)" characterPattern="^\d{2}/(0[1-9]|1[0-2])/\d{4}$" placeholder="dd-mm-yyyy HH:mm" slotChar="dd-mm-yyyy HH:mm"></p-inputMask>
                                      <!-- <p-calendar #theCalendar [readonlyInput]="true" [monthNavigator]="true" [yearNavigator]="true" [showTime]="true" [showSeconds]="false" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                                        dateFormat="dd-m-yy"></p-calendar> -->
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                    <label class="form-label" for="name"><br></label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <input type="checkbox" [checked]="this.transferlist[rowIndex]['detail'][0]['complimentaryfromsupplier']" readonly disabled="true"><span style="font-size: 14px;padding-left: 10px;">Complimentary from Supplier</span>
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <input type="checkbox" (change)="CompSuppCheckChange($event)" [checked]="tabCompSupCheck"><span style="font-size: 14px;padding-left: 10px;">Complimentary from Supplier</span>
                                    </div>
                                  </div>
                                </div>
                                
                              </div>
                              <div class="row">
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="name"><br></label>
                                  </div>
                                  <div class="col-12">
                                    <button type="button" style="float: left;" (click)="transferSingleEdit(rowIndex)"
                                      class="primary-default-btn">Edit</button>
                                    <button type="button" (click)="transferSingleCancel(rowIndex)"
                                      class="primary-default-btn">Cancel</button>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="name"><br></label>
                                  </div>
                                  <div class="col-12">
                                    <button type="button" style="float: left;" [disabled]="!this.isEdit" (click)="transferDetailSave(rowIndex)"
                                      class="primary-default-btn">Save</button>
                                  </div>
                                </div>
                              </div>
                            </p-tabPanel>
                            <p-tabPanel header="Remarks">
                              <div class="row">
                                <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12">
                                  <div class="col-12">
                                    <label class="form-label" for="supplierType">Remarks</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <textarea maxlength="400" pInputText type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['remarks']" rows="3"
                                        cols="20" wrap="hard" readonly disabled="true">
                                      </textarea>
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <textarea maxlength="400" pInputText [(ngModel)]="tabRemarks" type="text" rows="3"
                                        cols="20" wrap="hard">
                                      </textarea>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12">
                                  <div class="col-12">
                                    <label class="form-label" for="supplierType">Supplier Remarks</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <textarea maxlength="400" pInputText type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['supplier_remarks']" rows="3"
                                        cols="20" wrap="hard" readonly disabled="true">
                                      </textarea>
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <textarea maxlength="400" pInputText [(ngModel)]="tabSupplierRemarks" type="text" rows="3"
                                        cols="20" wrap="hard">
                                      </textarea>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12">
                                  <div class="col-12">
                                    <label class="form-label" for="supplierType">Customer Remarks</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <textarea maxlength="400" pInputText type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['customer_remarks']" rows="3"
                                        cols="20" wrap="hard" readonly disabled="true">
                                      </textarea>
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <textarea maxlength="400" pInputText [(ngModel)]="tabCustomerRemarks" type="text" rows="3"
                                        cols="20" wrap="hard">
                                      </textarea>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12">
                                  <div class="col-12">
                                    <label class="form-label" for="supplierType">Arrival Remarks</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <textarea maxlength="400" pInputText type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['arrival_remarks']" rows="3"
                                        cols="20" wrap="hard" readonly disabled="true">
                                      </textarea>
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <textarea maxlength="400" pInputText [(ngModel)]="tabArrivalRemarks" type="text" rows="3"
                                        cols="20" wrap="hard">
                                      </textarea>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12">
                                  <div class="col-12">
                                    <label class="form-label" for="supplierType">Departure Remarks</label>
                                  </div>
                                  <div class="col-12">
                                    <div *ngIf="!this.isEdit">
                                      <textarea maxlength="400" pInputText type="text" [(ngModel)]="this.transferlist[rowIndex]['detail'][0]['departure_remarks']" rows="3"
                                        cols="20" wrap="hard" readonly disabled="true">
                                      </textarea>
                                    </div>
                                    <div *ngIf="this.isEdit">
                                      <textarea maxlength="400" pInputText [(ngModel)]="tabDepartureRemarks" type="text" rows="3"
                                        cols="20" wrap="hard">
                                      </textarea>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="name"><br></label>
                                  </div>
                                  <div class="col-12">
                                    <button type="button" style="float: left;" (click)="transferSingleEdit(rowIndex)"
                                      class="primary-default-btn">Edit</button>
                                    <button type="button" (click)="transferSingleCancel(rowIndex)"
                                      class="primary-default-btn">Cancel</button>
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                                  <div class="col-12">
                                      <label class="form-label" for="name"><br></label>
                                  </div>
                                  <div class="col-12">
                                    <button type="button" style="float: left;" [disabled]="!this.isEdit" (click)="transferDetailSave(rowIndex)"
                                      class="primary-default-btn">Save</button>
                                  </div>
                                </div>
                              </div>
                            </p-tabPanel>
                          <!--</form>-->
                        </p-tabView>
                        <!-- <p-table styleClass="p-datatable-striped" [value]="[transferlist[rowIndex]]"
                            dataKey="RowNum">
                            <ng-template pTemplate="header">
                              <tr *ngIf="rowData['RowNum']==transferlist[rowIndex].RowNum">
                                <th>Flight No</th>
                                <th>Time</th> 
                                <th>Pickup Time</th>
                                <th>Transit Dep Flight No & Time</th>
                                <th>Customer</th>
                                <th>Driver Name</th>
                                <th>Pending amount from Guest</th>
                                <th>Pending amount for approval</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-order>
                              <tr *ngIf="rowData['RowNum']==transferlist[rowIndex].RowNum">
                                <td><span class="p-column-title">Flight No</span>{{product.flightcode}}</td>
                                <td><span class="p-column-title">Time</span>{{product.flighttime}}</td>
                                <td><span class="p-column-title">Pickup Time</span>{{product.pickupTime}}</td>
                                <td><span class="p-column-title">Transit Dep Flight No & Time</span>{{product.trdepflightcode}}  {{product.trdepflighttime}}</td>
                                <td><span class="p-column-title">Customer</span>{{product.agentname}}</td>
                                <td><span class="p-column-title">Driver Name</span>{{product.DriverName}}</td>
                                <td><span class="p-column-title">Pending amount from Guest</span></td>
                                <td><span class="p-column-title">Pending amount for approval</span></td>
                              </tr>
                            </ng-template>
                        </p-table> -->
                      </div>
                    </td>
                  </tr>
              </ng-template>
             </p-table>
            </div>
          </p-scrollPanel>
        </div>
      </div>  

      <p-dialog [style]="{width: '40%'}" header="Update Prior Time" [(visible)]="showPopupPriorTime">
        <p-progressSpinner *ngIf="popupLoading" [style]="{ 'position': 'absolute', 'left': '50%', 'top': '50%' }"></p-progressSpinner>
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6">
            <div class="col-12">
              <label class="form-label" for="name">Prior Time</label>
            </div>
            <div class="col-12">
              <input type="number" [min]="priorTimeMinValue" pInputText [(ngModel)]="txtPriorTime" placeholder="PriorTime">
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 ">
            <div class="col-12">
                <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12">
              <button type="button" style="float: left;" (click)="updatePriorTime(this.txtPriorTime)"
                class="primary-default-btn">Update Prior Time</button>
            </div>
          </div>
        </div>
      </p-dialog>

      <p-dialog [style]="{width: '80%'}" header="Send Email" [(visible)]="showPopupEmail">
        <p-scrollPanel [style]="{width: '100%', height: '65vh'}">
          <div style="width: 95%;margin: 20px;" class="card table-responsive">
            <p-table responsiveLayout="stack" (onPage)="onEmailPageChange($event)" [value]="emaillist"
            styleClass="p-datatable-gridlines" [loading]="loading" [paginator]="true" [rows]="10"
            [(first)]="emailPageIndex" [showCurrentPageReport]="true" dataKey="assignmentid"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10,20,50]">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <!-- <th>Id</th> -->
                <th>Voucher No</th>
                <th>Service</th>
                <th>Request Id</th>
                <th>Service Type</th>
                <th>Pickup Location</th>
                <th>DropOff Location</th> 
                <th>Total Pax</th>
                <th>Supplier Name</th> 
                <th>Guest Name</th>
                <th>Email</th>
                <th>Remarks</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData let-product let-columns="columns">
              <tr style="max-height: 30px;">
                <!-- <td>{{product.assignmentid}}</td> -->
                <td>{{product.VoucherNo}}</td>
                <td>{{product.ServiceType}}</td>
                <td>{{product.requestid}}</td>
                <td>{{product.assigntype}}</td>
                <td>{{product.pickupName}}</td>
                <td>{{product.dropoffName}}</td>
                <td>{{product.pax}}</td>
                <td>{{product.partyname}}</td>
                <td>{{product.Guestname}}</td>
                <!-- <td>{{product.email}}</td> -->
                <td>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input pInputText type="text"
                        [(ngModel)]="product.email">
                    </ng-template>
                    <ng-template pTemplate="output">
                      <input pOutputText type="text"
                        [(ngModel)]="product.email">
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td>{{product.remarks}}</td>
              </tr>
            </ng-template>
            </p-table>
            <div class="row">
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name"><br></label>
                </div>
                <div class="col-12">
                  <button type="button" style="float: left;" (click)="sendEmailToSupplier()"
                    class="primary-default-btn">Send Email</button>
                </div>
              </div>
            </div>
          </div>
        </p-scrollPanel>
      </p-dialog>


      <p-dialog [style]="{width: '80%'}" header="Driver Duty Sheet" [(visible)]="showPopupDriverDutySheet">
        <p-scrollPanel [style]="{width: '100%', height: '65vh'}">
          <div style="width: 95%;margin: 20px;" class="card table-responsive">
            <p-table responsiveLayout="stack" (onPage)="onDriverPageChange($event)" [value]="driverDutySheetlist"
            styleClass="p-datatable-gridlines" [loading]="loading" [paginator]="true" [rows]="10"
            [(first)]="driverPageIndex" [showCurrentPageReport]="true" dataKey="assignmentid"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10,20,50]">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th>Driver Name</th>
                <th>Service</th>
                <th>Service Date</th>
                <th>Request Id</th>
                <th>Pickup Location</th>
                <th>Pickup Time</th>
                <th>Guest Name</th>
                <th>Total Pax</th>
                <th>Flight No & Time</th>
                <th>DropOff Location</th>
                <th>Agent Name</th>
                <th>Agent Country</th>
                <th>Type of Vehicle</th>
                <th>Remarks</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData let-product let-columns="columns">
              <tr style="max-height: 30px;">
                <td>{{product.drivername}}</td>
                <td>{{product.transfertype}}</td>
                <td>{{product.transferdate | date:'dd-MM-yyyy'}}</td>
                <td>{{product.requestid}}</td>
                <td>{{product.pickupName}}</td>
                <td>{{formatTime(product.pickuptime)}}</td>
                <td>{{product.guestname}}</td>
                <td>{{product.noofpax}}</td>
                <td>{{product.flightcodetime}}</td>
                <td>{{product.dropoffName}}</td>
                <td>{{product.agentname}}</td>
                <td>{{product.ctryname}}</td>
                <td>{{product.othcatname}}</td>
                <td>{{product.remarks}}</td>
              </tr>
            </ng-template>
            </p-table>
            <div class="row">
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name"><br></label>
                </div>
                <div class="col-12">
                  <button type="button" style="float: left;" (click)="downloadDriverDutySheet()"
                    class="primary-default-btn">Download Excel</button>
                </div>
              </div>
            </div>
          </div>
        </p-scrollPanel>
      </p-dialog>
    </div>
</main>